
import React from 'react';
import AppLayout from '@/components/AppLayout';
import AuthModal from '@/components/zera/AuthModal';

const Index: React.FC = () => {
  return (
    <>
      <AppLayout />
      <AuthModal />
    </>
  );
};

export default Index;
